// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c3781dde","455":"dd6f68bc","977":"4dc35965"}[chunkId] + ".chunk.js";
};